import { useMemo } from 'react';
import { useApi } from 'src/new_arch/providers/ApiProvider';
import ScimSystem from './ScimSystem';

const useScimSystem = () => {
	const api = useApi();
	return useMemo( () => new ScimSystem( { api } ), [ api ] );
}

export default useScimSystem;
